import {
  AvailabilityTierAssignRequestType,
  AvailabilityTierAssignResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useAvailabilityTierAssign = (availabilityTierId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: AvailabilityTierAssignRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `availability-tiers/${availabilityTierId}/assign`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data).data as AvailabilityTierAssignResponseType,
      ),

    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.AvailabilityTiers],
      });
    },
  });
};
